@if (options.length) {
  <div class="dropdown-trigger" (click)="open($event)" [class.is-open]="isOpen">
    @if (icon) {
      <span class="dropdown-icon mb-icon {{ icon }}"></span>
    }
    @if (!hideLabel) {
      <span class="dropdown-label">
        @if (labelTpl) {
          <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
        } @else {
          {{ valueLabel || options[0].label | translate }}
        }
      </span>
    }
    @if (!hideLabel) {
      <span
        class="dropdown-indicator mb-icon mb-icon-down"
        [class.is-open-top]="openTop"
        [class.invert]="isOpen"
      ></span>
    }
  </div>
  @if (!useNativeDropdown) {
    <div class="dropdown-container" [class.open-top]="openTop" [class.is-open]="isOpen">
      @for (option of options; track option.value) {
        <div class="dropdown-option" (click)="optionSelected(option)" [class.active]="option.value === value">
          {{ option.label | translate: option.translationData || {} }}
        </div>
      }
    </div>
  }
  @if (useNativeDropdown) {
    <select class="maximize-content dropdown-native-container" #selectEl (change)="nativeOptionSelect(selectEl.value)">
      @for (option of options; track option.value) {
        <option class="mb-dropdown-option" [value]="option.value" [selected]="option.value === value">
          {{ option.label | translate: option.translationData || {} }}
        </option>
      }
    </select>
  }
}
